import { Grid } from '@mui/material'
import React from 'react'
import { AutocompleteElement, TextFieldElement } from 'react-hook-form-mui'
import isEmail from 'validator/es/lib/isEmail'
import dealershipBrandsDict, { dealershipBrandOptions } from '../../constants/dealershipBrands'
import { useGetDealerships } from '../../hooks/api/dealerships'
import { useAuth } from '../../hooks/context/UserAuthContext'

const CustomerForm = ({
  disableEdit = false,
  dealershipOptional = false,
  phoneOptional = false,
  control,
  userForm = false,
  onDealershipChange = () => {},
  disableDealership = false,
  user,
  dealershipBrand,
}) => {
  const auth = useAuth()
  user ??= userForm ? {} : auth?.user
  const { isLoading: dealershipsLoading, data: dealerships } = useGetDealerships(
    dealershipBrand ? { brand: dealershipBrand } : {},
    { enabled: !disableEdit || !user?.dealership || userForm }
  )

  return (
    <>
      <Grid item xs={12} md={6}>
        <TextFieldElement
          control={control}
          name='email'
          label='Email Address'
          required={!user?.email}
          type='email'
          inputProps={{
            inputMode: 'email',
          }}
          disabled={Boolean(user?.email && disableEdit)}
          validation={{
            required: !user?.email && 'Email address is required.',
            validate: (email) => !email || isEmail(email) || 'Invalid email address.',
          }}
          fullWidth
          placeholder={user?.email}
          InputLabelProps={{
            shrink: Boolean(user?.email && disableEdit) || Boolean(user?.email) || undefined,
          }}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextFieldElement
          control={control}
          name='phone'
          label={`Mobile Phone Number${!phoneOptional && !user?.phone ? ' *' : ''}`}
          type='tel'
          inputProps={{
            inputMode: 'tel',
          }}
          disabled={Boolean(user?.phone && disableEdit)}
          validation={{
            validate: (value) =>
              !(!phoneOptional && !user?.phone && !value) || 'Mobile phone number is required',
          }}
          fullWidth
          placeholder={user?.phone}
          InputLabelProps={{
            shrink: Boolean(user?.phone) || undefined,
          }}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextFieldElement
          control={control}
          name='firstName'
          label='First name'
          disabled={Boolean(user && disableEdit)}
          fullWidth
          placeholder={user?.firstName}
          InputLabelProps={{
            shrink: Boolean(user && disableEdit) || Boolean(user?.firstName) || undefined,
          }}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextFieldElement
          control={control}
          name='lastName'
          label='Last name'
          disabled={Boolean(user && disableEdit)}
          fullWidth
          placeholder={user?.lastName}
          InputLabelProps={{
            shrink: Boolean(user && disableEdit) || Boolean(user?.lastName) || undefined,
          }}
        />
      </Grid>
      {!disableDealership && (
        <Grid item xs={12}>
          {!disableEdit || !user?.dealership ? (
            <AutocompleteElement
              control={control}
              name='dealership'
              label={`Dealership${!dealershipOptional && !user?.dealership ? ' *' : ''}`}
              loading={dealershipsLoading}
              matchId
              autocompleteProps={{
                onChange: onDealershipChange,
              }}
              options={(dealerships || []).map(({ _id, name, brand }) => ({
                id: _id,
                name,
                brand,
                label: `${dealershipBrandsDict[brand] || brand} - ${name}`,
              }))}
              fullWidth
              rules={{
                validate: (value) =>
                  !(!dealershipOptional && !user?.dealership && !value) || 'Dealership is required',
              }}
            />
          ) : (
            <TextFieldElement
              control={control}
              name='dealership'
              label='Dealership'
              disabled
              fullWidth
              placeholder={`${
                dealershipBrandsDict[user.dealership.brand] || user.dealership.brand
              } - ${user.dealership.name}`}
              InputLabelProps={{ shrink: true }}
            />
          )}
        </Grid>
      )}
    </>
  )
}

export default CustomerForm
